import { Link } from 'react-router-dom';
import { categories } from '@/mocks/movies';

export default function Footer() {
  return (
    <footer className="bg-background-100 border-t border-background-200/60">
      <div className="w-full px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <div className="w-9 h-9 flex items-center justify-center bg-primary-500 rounded-lg">
                <i className="ri-movie-2-line text-foreground-50 text-lg"></i>
              </div>
              <span className="font-heading text-lg font-bold text-foreground-50">
                91影视
              </span>
            </div>
            <p className="text-foreground-400 text-sm leading-relaxed">
              免费影视大全，提供高清电影电视剧在线观看。天美麻花星空影视免费观看电视，每日更新最新影视资源，高清不缓冲。
            </p>
          </div>

          <div>
            <h4 className="font-heading text-foreground-100 font-semibold mb-4">影视分类</h4>
            <ul className="space-y-2">
              {categories.slice(0, 6).map((cat) => (
                <li key={cat.slug}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-foreground-400 hover:text-primary-400 text-sm transition-colors duration-200"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-foreground-100 font-semibold mb-4">热门推荐</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/article/movie-1" className="text-foreground-400 hover:text-primary-400 text-sm transition-colors duration-200">
                  流浪地球3
                </Link>
              </li>
              <li>
                <Link to="/article/movie-2" className="text-foreground-400 hover:text-primary-400 text-sm transition-colors duration-200">
                  封神第二部
                </Link>
              </li>
              <li>
                <Link to="/article/movie-3" className="text-foreground-400 hover:text-primary-400 text-sm transition-colors duration-200">
                  热辣滚烫2
                </Link>
              </li>
              <li>
                <Link to="/article/movie-7" className="text-foreground-400 hover:text-primary-400 text-sm transition-colors duration-200">
                  长安三万里2
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-foreground-100 font-semibold mb-4">关于我们</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/about" className="text-foreground-400 hover:text-primary-400 text-sm transition-colors duration-200">
                  品牌介绍
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-foreground-400 hover:text-primary-400 text-sm transition-colors duration-200">
                  用户口碑
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-foreground-400 hover:text-primary-400 text-sm transition-colors duration-200">
                  联系我们
                </Link>
              </li>
            </ul>
            <div className="flex items-center gap-3 mt-4">
              <a href="#" className="w-8 h-8 flex items-center justify-center rounded-lg bg-background-200/50 text-foreground-400 hover:text-primary-400 hover:bg-background-300/50 transition-colors" rel="nofollow">
                <i className="ri-wechat-line"></i>
              </a>
              <a href="#" className="w-8 h-8 flex items-center justify-center rounded-lg bg-background-200/50 text-foreground-400 hover:text-primary-400 hover:bg-background-300/50 transition-colors" rel="nofollow">
                <i className="ri-weibo-line"></i>
              </a>
              <a href="#" className="w-8 h-8 flex items-center justify-center rounded-lg bg-background-200/50 text-foreground-400 hover:text-primary-400 hover:bg-background-300/50 transition-colors" rel="nofollow">
                <i className="ri-bilibili-line"></i>
              </a>
            </div>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-background-200/40 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-foreground-500 text-xs">
            &copy; 2026 91影视看片下载 - 天美麻花星空影视免费观看电视 版权所有
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-foreground-500 hover:text-foreground-300 text-xs transition-colors" rel="nofollow">隐私政策</a>
            <a href="#" className="text-foreground-500 hover:text-foreground-300 text-xs transition-colors" rel="nofollow">服务条款</a>
            <a href="#" className="text-foreground-500 hover:text-foreground-300 text-xs transition-colors" rel="nofollow">免责声明</a>
          </div>
        </div>
      </div>
    </footer>
  );
}